import classNames from 'classnames';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Activity from '../Activity';
import { AppBanner } from '../AppBanner';
import { Point, UserInfo } from '../index';
import { Header } from '../Header';
import PointHistory from '../PointHistory';
import UserInfoContent from '../UserInfoContent';
import FooterBanner from '../FooterBanner';

import styles from './styles.module.scss';
import { isMobile } from 'react-device-detect';

interface Props {
  userInfo: UserInfo;
  openUseAppForBestExperienceModal?: boolean;
  onCloseUseAppForBestExperienceModal?(): void;
}

export const Profile: React.FC<Props> = (props) => {
  const { userInfo, openUseAppForBestExperienceModal } = props;
  const location = useLocation();
  const navigate = useNavigate();

  const [selectedPoint, setSelectedPoint] = useState<Point | null>(null);

  const moveEditingPage = () => navigate('/edit', { state: location.state });

  const dodoLogo = (
    <img src={require('../../images/dodo-point-logo-grey.png')} className={styles.dodoLogo} alt="dodo point logo" />
  );

  let header: React.ReactNode;

  if (isMobile) {
    header = <AppBanner country={userInfo.country} />;
  } else {
    header = <Header title={dodoLogo} />;
  }

  return (
    <div
      className={classNames(styles.container, openUseAppForBestExperienceModal)}
      aria-hidden={openUseAppForBestExperienceModal}
    >
      {header}
      <div className={styles.content} style={{ paddingBottom: '31.2%' }}>
        <UserInfoContent userInfo={userInfo} onClickEditingButton={moveEditingPage} />
        <PointHistory userInfo={userInfo} onClick={setSelectedPoint} />
        {selectedPoint && (
          <Activity
            userInfo={userInfo}
            onClose={() => {
              setSelectedPoint(null);
            }}
            point={selectedPoint}
          />
        )}
      </div>
      {!selectedPoint && <FooterBanner target="profile" userInfo={userInfo} />}
      {/* 하단 팝업을 다시 사용할 경우에 주석 제거 후 재사용 해야 함 */}
      {/* {userInfo.country === Country.KR &&
                openUseAppForBestExperienceModal && (
                    <UseAppForBestExperienceModal
                        onClose={() =>
                            onCloseUseAppForBestExperienceModal &&
                            onCloseUseAppForBestExperienceModal()
                        }
                    />
                )} */}
    </div>
  );
};

export default Profile;
